/*
loading: false,
        responseBody: (action.type) ? action : action.payload.error,
        error: action.payload.message,
        errorObject:action.payload
        */
import moment from 'moment';


        class Metric{
            constructor(params,o){
                this.id = o.id;
                this.accountType = "Metric";
                this.params = {
                  createdAt:'',
                  updatedAt:'',
                  abbr:'',
                  id:'',
                  label:'',
                  filters:'',
                  formula:'',
                  format:'',
                  description:'',
                  definition:'',
                  configuration:'{}',
                  generic:{},
                  defaultSettings:'{}',
                }
        
            this.setParameters(o);
        
            
                }
            
            
            setParameters(params){
                    for (var prop in params){
                        if (params.hasOwnProperty(prop)){
                            var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                            if (this[method]){
                               this[method](params[prop]);
                            }
                            
                        }
                    }
        
                }
                
               
              setCreatedAt(str){this.createdAt = str;}
              setUpdatedAt(val){this.updatedAd = val;}
              setNick(str){this.nick = str;}
              setAbbr(val){this.abbr = val;}
              setLabel(val){this.label = val;}
              setFilters(val){this.filters = (val && val != "") ? JSON.parse(val) : val;}
              setName(val){this.name = val;}
              setFormula(val){this.formula = (val && val != "") ? JSON.parse(val) : val;}
              setFormat(val){this.format = val;}
              setId(val){this.id = val;}
              setDescription(val){this.description = val;}
              setDefinition(val){this.definition = val;}

           
                }
        export default Metric;
                  